import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Paper, Button } from '@material-ui/core';
import { ROLE_CODE } from '../../common/const';
import './SubMenu.css';

/**
 * 共通ヘッダコンポーネント
 */
class SubMenu extends Component {
  render() {
    const {
      userInfo,
    } = this.props;

    //  取引情報アップロード
    let uploadcompanyinfo = '';
    if (userInfo.transaction_contact === 1
      && userInfo.role_list.indexOf(ROLE_CODE.UPLOAD) >= 0) {
      uploadcompanyinfo = (
        <Button className="subButton" component={Link} to="/uploadcompanyinfo">
          <div>取引情報アップロード</div>
        </Button>
      );
    }

    // ユーザー管理
    let usermanaged = '';
    if (userInfo.role_list.indexOf(ROLE_CODE.USERMANAGED) >= 0) {
      usermanaged = (
        <Button className="subButton" component={Link} to="/usermanaged">
          <div>ユーザー管理</div>
        </Button>
      );
    }

    // 利用状況照会
    let logoutput = '';
    if (userInfo.role_list.indexOf(ROLE_CODE.LOGOUTPUT) >= 0) {
      logoutput = (
        <Button className="subButton" component={Link} to="/logoutput">
          <div>利用状況照会</div>
        </Button>
      );
    }

    // 外部データ連携履歴
    let externaldata = '';
    if ((userInfo.businesscard_contact === 1 || userInfo.common_contract === 1)
      && userInfo.role_list.indexOf(ROLE_CODE.EXTERNALDATA) >= 0) {
      externaldata = (
        <Button className="subButton" component={Link} to="/externaldata">
          <div>外部データ連携履歴</div>
        </Button>
      );
    }

    return (
      <Paper
        elevation={3}
        className="submenufield"
      >
        <div className="linkfield">
          {uploadcompanyinfo}
          {usermanaged}
          {logoutput}
          {externaldata}
        </div>
      </Paper>
    );
  }
}

export default connect(
  (state) => ({
    userInfo: state.common.userInfo,
  }),
)(withRouter(SubMenu));
